import moment from "moment";
import React, { Fragment, useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { Link, useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Table
} from "reactstrap";
import Breadcrumbs from "../../layout/breadcrumb";
import Loader from "../../layout/loader";
import RadarChart from "./RadarChart";
import "./Reports.css";

export default function Reports() {
  const navigate = useNavigate();
  const location = useLocation();

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const token = document.cookie.split(`jwt=`).pop().split(";").shift();
  //Fetch API call
  const fetchData = async () => {
    setLoading(true);
    const request = {
      method: "POST",
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-requested-With, Content-Type, Accept",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({ start_date: startDate, end_date: endDate }),
    };
    try {
      const responce = await fetch(
        `https://lsreport.shls.care/api/users/user/duo/all${(location.state && location.state.user) ? "?user_id=" + location.state.user?.user_id : ""
        }`,
        request,
        { mode: "cors" }
      );
      if (responce.status === 200) {
        let data = await responce.json();
        setData(data);
      } else {
        toast.error(await responce.json());
      }
    } catch (err) {
      setLoading(false);
      toast.error(err.message);
    }
    setLoading(false);
  };

  const exportData = async () => {
    setLoading(true);
    const request = {
      method: "POST",
      headers: {
        // 'Accept': GetMineType(ext),
        "Content-type": "application/json; charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-requested-With, Content-Type, Accept",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({ start_date: startDate, end_date: endDate }),
    };
    try {
      var responce = await fetch(
        `https://lsreport.shls.care/api/users/duo/all/export?user_id=${location.state && location.state.user.user_id
        }`,
        request,
        { mode: "cors" }
      );
      if (responce.status === 200) {
        const blob = await responce.blob();
        const downloadLink = document.createElement("a");
        const url = window.URL.createObjectURL(blob);
        downloadLink.href = url;
        downloadLink.download =
          location.state && location.state.user ?
            location.state.user.user_firstname +
            "_" +
            location.state.user.user_lastname +
            ".xlsx" : "Rapport_duo_all.xlsx"; // Set the desired file name
        document.body.appendChild(downloadLink);
        downloadLink.click();

        // Clean up resources
        document.body.removeChild(downloadLink);
        window.URL.revokeObjectURL(url);
        toast.success("success");
      } else {
        toast.error(await responce.json());
      }
    } catch (err) {
      setLoading(false);
      toast.error(err.message);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
    window.scrollTo(0, 0);
  }, []);

  return (
    <Fragment>
      <Loader isLoading={loading} />
      <Breadcrumbs parent="Visites Duo" title="Fiches Duo" />
      <Container fluid={true} className="pb-4 mb-4">
        <Row className="mb-3 d-flex justify-content-between">
          <Col md="2">
            <label htmlFor="">Du:</label>
            <DatePicker
              dateFormat={"dd/MM/yyyy"}
              selected={startDate}
              maxDate={new Date()}
              onChange={(date) => setStartDate(date)}
            />
          </Col>
          <Col md="2">
            <label htmlFor="">Au:</label>
            <DatePicker
              dateFormat={"dd/MM/yyyy"}
              minDate={startDate}
              maxDate={new Date()}
              selected={endDate}
              onChange={(date) => setEndDate(date)}
            />
          </Col>
          <Col md="2">
            <Button
              className="btn-block"
              color="warning"
              onClick={() => {
                fetchData();
              }}
              style={{ marginTop: "32px" }}
            >
              Rechercher
            </Button>
          </Col>
          <Col md={2} className="d-flex align-items-end">
            <button
              className="btn btn-info b-r-0 ourBtn btn-block "
              onClick={() =>
                navigate({
                  pathname: `/visitesDuo/add`,
                }, {
                  state: {
                    agent_id: location.state && location.state.user?.user_id,
                    agent_lastname:
                      location.state && location.state.user?.user_lastname,
                    agent_firstname:
                      location.state && location.state.user?.user_firstname,
                  },
                })
              }
            >
              Ajouter
            </button>
          </Col>
          <Col md={2} className="d-flex align-items-end">
            <button
              className="btn btn-block btn-success mr-2"
              onClick={() => {
                exportData();
              }}
            >
              {" "}
              Exporter
            </button>
          </Col>
        </Row>
        <Row className="pb-4">
          <Col xs="12" className="o-auto pb-4">
            {data.length === 0 ? (
              <Card className="text-align-center">
                <CardBody style={{ textAlign: "center" }}>
                  <h4>Aucun rapport à afficher</h4>
                </CardBody>
              </Card>
            ) : (
              <Table className="mb-4" style={{ backgroundColor: "white" }}>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Date</th>
                    <th>Visiteur</th>
                    <th>Superviseur</th>
                    <th>Secteur</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((fiche) => {
                    return (
                      <tr key={data.indexOf(fiche)}>
                        <td>{data.indexOf(fiche) + 1}</td>
                        <td>
                          {fiche &&
                            moment(fiche.duo_date).format("YYYY-MM-DD")}
                        </td>
                        <td>
                          {fiche?.visitor_lastname}{" "}
                          {fiche.visitor_firstname}
                        </td>
                        <td>
                          {fiche?.supervisor_lastname}{" "}
                          {fiche.supervisor_firstname}
                        </td>
                        <td>{fiche && fiche.duo_wilaya}</td>
                        <td style={{ textAlign: "center" }}>
                          <Link
                            to={{
                              pathname: `/visiteDuo/rapportDetails`,
                            }}
                            state={{
                              fiche,
                              visiteur: `${location.state &&
                                location.state.user?.user_lastname
                                } ${location.state &&
                                location.state.user?.user_firstname
                                }`,
                            }}
                          >
                            <i style={{ paddingRight: 10 }} className="fa fa-table" id="TooltipExample"></i>
                          </Link>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            )}
            {
              data && location.state &&
              <RadarChart data={data} />
            }
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
}
